import { useCallback } from "react";
import { Outlet, createRootRoute, useRouter, useRouterState } from "@tanstack/react-router";
import { useCsrfToken } from "@amber/access/ui";
import { UiProvider } from "@amber/ui";
import { NotFoundPage } from "../pages/NotFound";

function Root() {
  const router = useRouter();
  const csrf = useCsrfToken();
  const navigate = useCallback(
    (href: string) => {
      void router.navigate({ href });
    },
    [router],
  );
  return (
    <UiProvider navigate={navigate} csrf={csrf}>
      <Outlet />
    </UiProvider>
  );
}

function NotFoundRoute() {
  const href = useRouterState({ select: (s) => s.location.href });
  return <NotFoundPage lookedUp={href} />;
}

export const rootRoute = createRootRoute({ component: Root, notFoundComponent: NotFoundRoute });
